const BASE_URI = process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : 'https://mighty-bastion-63658.herokuapp.com/';

export default BASE_URI;
